import React, { useState } from 'react';
import WarSwiper from './WarSwiper';
import Leaderboard from './Leaderboard';
import { formatTimestamp } from '../utils/formatTime';

export default function Dashboard({ t, lang, leaderboardData, isLeaderboardLoading, warInfo, warHistory, lastSyncAt, seasons, currentSeason, serverCurrentSeason, onSeasonChange, formatSeasonLabel, slug }) {
  const [searchTerm, setSearchTerm] = useState('');

  const isCurrent = currentSeason === serverCurrentSeason;

  // Build deduplicated war list: current war + history, skip duplicates
  const wars = (() => {
    const all = [];
    if (warInfo) all.push(warInfo);
    for (const w of (warHistory || [])) {
      // When a war ends it exists in both current_war and war_log — skip the duplicate
      if (warInfo && w.startTime && w.startTime === warInfo.startTime) continue;
      all.push(w);
    }
    return all.slice(0, 5);
  })();

  return (
    <div id="dashboardPage">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-6">
        <h1 className="text-2xl md:text-3xl">🔥 <span>{t('page_dashboard')}</span></h1>
        {lastSyncAt && (
          <div className="dash-sync-tag" title={t('last_sync')}>
            🔄 {formatTimestamp(lastSyncAt)}
          </div>
        )}
      </div>

      <WarSwiper t={t} wars={wars} />

      {/* Season Selector */}
      <div id="seasonSelector" className="dash-season-row">
        <div className="dash-season-card">
          <span className="dash-season-icon">📅</span>
          <span className="dash-season-label">{t('season_label')}</span>
          <select
            id="seasonDropdown"
            value={currentSeason}
            onChange={(e) => onSeasonChange(e.target.value)}
            className="dash-season-select"
            aria-label="Season"
          >
            {seasons.map(s => (
              <option key={s} value={s}>{formatSeasonLabel(s)}</option>
            ))}
          </select>
          {isCurrent && (
            <span id="seasonBadge" className="dash-current-pill">{t('current_badge')}</span>
          )}
        </div>
      </div>

      {/* Leaderboard */}
      <div className="dash-section">
        <div className="dash-section-header">
          <h2 className="dash-section-title">
            <span className="dash-section-icon">🏆</span>
            <span>{t('page_leaderboard')}</span>
          </h2>
          <input
            id="leaderboardSearch"
            type="text"
            placeholder={t('col_player_name') + '...'}
            aria-label="Search leaderboard"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="dash-search-input"
          />
        </div>
        <Leaderboard t={t} data={leaderboardData} searchTerm={searchTerm} slug={slug} isLoading={isLeaderboardLoading} />
      </div>
    </div>
  );
}
